<template>
	<div>
		<div v-if="image.preview" style="line-height: 0;" :style="{ width: widthReal + 'px' }">
			<div class="preview-box">
				<img class="preview" :src="image.preview" :style="{ height: heightReal + 'px', width: widthReal+ 'px' }" />
			</div>
			<div class="preview-info">
				<div class="name v-ellipsis">{{ image.name }}</div>
				<a class="operate-btn v-mr-10" :href="image.preview" target="_blank"><i class="el-icon-zoom-in"></i></a>
				<el-popconfirm title="确认删除?" @onConfirm="deleteImage">
					<i slot="reference" class="operate-btn el-icon-delete"></i>
				</el-popconfirm>
			</div>
		</div>
		<div v-else v-loading="loading" class="add-btn" :style="{ height: heightReal + 'px', width: widthReal + 'px' }" @click="select">
			<i class="icon el-icon-plus"></i>
		</div>
		<input ref="imageInput" hidden type="file" accept="image/*" />
	</div>
</template>

<script>
	export default {

		model: {
			prop: "image",
			event: "change"
		},
		props: {
			width: {
				type: String,
				default: "150"
			},
			height: {
				type: String,
				default: "150"
			},
			image: {
				type:Object,
				default:()=>({})
			}
		},

		data() {
			return {
				loading: false
			};
		},

		computed: {
			widthReal() {
				return this.width > 300 ? 300 : this.width;
			},

			heightReal() {
				return this.width > 300 ? this.height / (this.width / 300) : this.height;
			}
		},

		methods: {
			deleteImage() {
				this.$emit("change", {key: "".key, preview: "", name: ""});
			},

			select() {
				let input = this.$refs.imageInput;
				input.click();
				input.onchange = e => {
					let files = e.target.files;
					this.doUpload(files);
				};
			},

			//上传文件
			async doUpload(files) {
				this.loading = true;
				try {
					let res = await this.utils.upload.uploadFiles(files);
					this.$emit("change", {
						key: res[0].key,
						preview: res[0].preview,
						name: res[0].name
					});
				} catch (e) {
					console.error(e);
				}
				this.$refs.imageInput.value = "";
				this.loading = false;
			}
		}
	};
</script>

<style scoped>
	.add-btn {
		width: 150px;
		height: 150px;
		border-radius: 4px;
		border: 1px dashed #999;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.preview-box {
		border: 1px solid #eee;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.preview {
		max-width: 100%;
		max-height: 100%;
    border: 1px solid #ccc;
		display: block;
		background: #ccc;
	}

	.preview-info {
		display: flex;
		align-items: center;
		line-height: 30px;
		background: rgba(0, 0, 0, 0.3);
		color: #fff;
		box-sizing: border-box;
		padding: 0 5px;
	}

	.preview-info .name {
		flex: 1;
		font-size: 12px;
	}

	.operate-btn {
		cursor: pointer;
		color: #fff;
	}
</style>
